import { PageLoader } from '@/components/ui/PageLoader'
import { Forbidden } from '@/components/ui/Forbidden'
import { usePermissions, type PermissionKey } from '@/services/permissions'

interface PermissionRouteProps {
  /** One key, or several of which any one is enough. */
  permission: PermissionKey | PermissionKey[]
  children: React.ReactNode
}

/**
 * Page-level gate. Waits for the caller's permissions before deciding, so a refresh never
 * flashes the Forbidden page at someone who is allowed in.
 */
export const PermissionRoute = ({ permission, children }: PermissionRouteProps) => {
  const { canAny, isLoading } = usePermissions()
  if (isLoading) return <PageLoader />

  const keys = Array.isArray(permission) ? permission : [permission]
  return canAny(...keys) ? <>{children}</> : <Forbidden />
}
